import React from "react";
import { Typography, Button, CenterInView } from "investira.react.components";
import { GENERIC, MESSAGES } from "../../../const";
import Style from "./ErrorBody.module.scss";

/**
 * Renderiza o componente ErrorBody.
 *
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
function ErrorBody(props) {
  return (
    <div className={Style.root}>
      <CenterInView>
        <div className={Style.body}>
          {props.d !== "" && (
            <div className={Style.img}>
              <svg
                x="0px"
                y="0px"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
              >
                <path
                  className={Style.fill}
                  d={
                    props.d ||
                    "M21.787 20.342h0.038l-0.395-0.372-19.325-18.22-0.193 1.033c-0.059 0.312 0.030 0.541 0.216 0.767l0.461 0.48 1.819 1.715c-2.608 1.804-3.936 4.987-3.086 8.121 0.256 0.942 0.712 1.833 1.322 2.624 0 0-0.010 0.001-0.008 0.004 1.308 1.755 4.402 3.244 7.055 3.244h7.836c0.439 0 0.932-0.096 1.445-0.261l2.941 2.773 0.194-1.033c0.059-0.313-0.031-0.541-0.217-0.768l-0.103-0.107zM17.836 18.407c-0.105 0.010-0.201 0.041-0.309 0.041h-7.831c-2.154 0.003-4.408-0.994-5.698-2.418-0.634-0.726-1.106-1.577-1.35-2.485-0.727-2.679 0.48-5.378 2.77-6.848l12.418 11.71zM7.602 5.008c0-0.273 0.178-0.508 0.432-0.607l0.302-0.090c1.837-0.256 3.393 0.118 5.014 1.022 1.721 0.959 2.985 2.448 3.597 4.226h0.66c0 0 0.003 0 0.003 0 1.738 0 3.373 0.801 4.375 2.144 1.379 1.853 1.158 4.185-0.056 5.822l-0.154 0.124c-0.12 0.109-0.283 0.18-0.465 0.18-0.37 0-0.671-0.283-0.671-0.634 0-0.191 0.096-0.355 0.236-0.472 0.913-1.257 0.969-2.963-0.012-4.28-0.743-0.998-1.961-1.595-3.253-1.595-0.001 0-0.001 0-0.003 0h-1.173c-0.313 0-0.586-0.2-0.663-0.485-0.451-1.658-1.558-3.050-3.119-3.92-1.281-0.718-2.744-0.965-4.201-0.804-0.049 0.011-0.097 0.029-0.152 0.029-0.025 0-0.044-0.011-0.068-0.012-0.019 0.003-0.040 0.001-0.060 0.004l-0.022-0.020c-0.312-0.067-0.548-0.317-0.548-0.633z"
                  }
                />
              </svg>
            </div>
          )}

          <Typography variant={"body1"} color={"textPrimary"} gutterBottom>
            {props.message || MESSAGES.GENERIC.ERROR}
          </Typography>

          <Button
            onClick={props.handleClick}
            variant={"outlined"}
            color={"primary"}
          >
            {GENERIC.GENERIC.TRY_AGAIN}
          </Button>
        </div>
      </CenterInView>
    </div>
  );
}

export default ErrorBody;
